// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  // Start #204966 
  InstantSearchResultItemProduct.prototype.beforeRender = function () {
    if (this.url) {
      this.url = buildCustomProductItemUrlWithVariant(this.data);
    }
  }

  function buildCustomProductItemUrlWithVariant(data) {
    var variantIdPart = data.split_product && data.variants ? ("?variant=" + data.variants[0].id) : "";
	var productUrl = Utils.buildProductItemUrl(data, false);
	return productUrl + variantIdPart;
  }
  // End #204966
})();